import { Routes } from '@angular/router';

import { adminAuthGuard } from '@app/core/guards/admin-auth.guard';
import { HomeComponent } from '@app/pages/home/home.component';

export const routes: Routes = [
  {
    path: '',
    children: [
      { path: 'home', component: HomeComponent },
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      {
        path: 'buyer-guide',
        loadComponent: () =>
          import('@app/guides/buyer-guide/buyer-guide.component').then(
            (m) => m.BuyerGuideComponent,
          ),
      },
      {
        path: 'seller-guide',
        loadComponent: () =>
          import('@app/guides/seller-guide/seller-guide.component').then(
            (m) => m.SellerGuideComponent,
          ),
      },
      {
        path: 'contact-page',
        loadComponent: () =>
          import('@app/pages/contact-page/contact-page.component').then(
            (m) => m.ContactPageComponent,
          ),
      },
      {
        path: 'home-estimate-page',
        loadComponent: () =>
          import('@app/pages/home-estimate-page/home-estimate-page.component').then(
            (m) => m.HomeEstimatePageComponent,
          ),
      },
      {
        path: 'agents/:slug',
        loadComponent: () =>
          import('@app/pages/agent-profile/agent-profile.component').then(
            (m) => m.AgentProfileComponent,
          ),
      },
      {
        path: 'agents',
        loadComponent: () =>
          import('@app/pages/agents/agents.component').then((m) => m.AgentsComponent),
      },
      {
        path: 'admin',
        loadComponent: () =>
          import('@app/pages/admin-page/admin-page.component').then((m) => m.AdminPageComponent),
        canActivate: [adminAuthGuard],
      },
      {
        path: 'featured-properties',
        loadChildren: () =>
          import('@app/listings/featured-properties/featured-properties.routes').then(
            (m) => m.FEATURED_PROPERTIES_ROUTES,
          ),
      },
      {
        path: 'for-rent',
        loadChildren: () =>
          import('@app/pages/for-rent/for-rent.routes').then((m) => m.FOR_RENT_ROUTES),
      },
      {
        path: 'favorite-properties',
        loadComponent: () =>
          import('@app/pages/favorite-properties/favorite-properties.component').then(
            (m) => m.FavoritePropertiesComponent,
          ),
      },
      {
        path: 'zestimate',
        loadComponent: () =>
          import('@app/pages/zestimate/zestimate.component').then((m) => m.ZestimateComponent),
      },
    ],
  },
];
